import { ArrowBackIcon } from './arrow-back';
import { ArrowDownIcon } from './arrow-down';
import { ArrowForwardIcon } from './arrow-forward';
import { ArrowLeftIcon } from './arrow-left';
import { ArrowRightIcon } from './arrow-right';
import { ArrowUpIcon } from './arrow-up';
import { BasketIcon } from './basket';
import { CalendarIcon } from './calendar';
import { CashPaymentIcon } from './cash-payment';
import { CashWithdrawalIcon } from './cash-withdrawal';
import { CheckIcon } from './check';
import { CheckListIcon } from './checklist';
import { CloseIcon } from './close';
import { DoubleArrowLeftIcon } from './double-arrow-left';
import { DoubleArrowRightIcon } from './double-arrow-right';
import { DrawIcon } from './draw';
import { EmployeesIcon } from './employees';
import { EuroIcon } from './euro';
import { EventAvailableIcon } from './event-available';
import { Exit } from './exit';
import { FileDownloadIcon } from './file-download';
import { FileUploadedIcon } from './file-uploaded';
import { GearIcon } from './gear';
import { GiftCardIcon } from './gift-card';
import { GridIcon } from './grid';
import { HamburgerMenuIcon } from './hamburger-menu';
import { HomeIcon } from './home';
import { HomeWorkIcon } from './home-work';
import { ImportIcon } from './import';
import { InfoIcon } from './info';
import { InviteIcon } from './invite';
import { LinkIcon } from './link';
import { LocalOfferIcon } from './local-offer';
import { PenIcon } from './pen';
import { PlusIcon } from './plus';
import { Save } from './save';
import { SearchIcon } from './search';
import { SellIcon } from './sell';
import { SignOutIcon } from './sign-out';
import { SuccessIcon } from './success';
import { Sync } from './sync';
import { SyncDisabled } from './sync-disabled';
import { TrashIcon } from './trash';
import { TravelIcon } from './travel';
import { FileUploadIcon } from './upload';
import { WarningIcon } from './warning';

export enum IconName {
  Draw = 'draw',
  Euro = 'euro',
  ArrowRight = 'arrow-right',
  ArrowUp = 'arrow-up',
  ArrowDown = 'arrow-down',
  ArrowBack = 'arrow-back',
  Link = 'link',
  EventAvailable = 'event-available',
  LocalOffer = 'local-offer',
  Travel = 'travel',
  GiftCard = 'gift-card',
  Info = 'info',
  Home = 'home',
  Grid = 'grid',
  Basket = 'basket',
  SignOut = 'sign-out',
  ArrowForward = 'arrow-forward',
  Close = 'close',
  Success = 'success',
  Warning = 'warning',
  DoubleArrowLeft = 'double-arrow-left',
  DoubleArrowRight = 'double-arrow-right',
  HamburgerMenu = 'hamburger-menu',
  FileDownload = 'file-download',
  Trash = 'trash',
  FileUploadIcon = 'file-upload',
  FileUploadedIcon = 'file-uploaded',
  Calendar = 'calendar',
  Employees = 'employees',
  CashWithdrawal = 'cash-withdrawal',
  CashPayment = 'cash-payment',
  Search = 'search',
  Plus = 'plus',
  ArrowLeft = 'arrow-left',
  Pen = 'pen',
  Check = 'check',
  HomeWork = 'home-work',
  CheckList = 'checklist',
  Gear = 'gear',
  Import = 'import',
  Invite = 'invite',
  Sync = 'sync',
  SyncDisabled = 'sync-disabled',
  MobilityBudget = 'mobility-budget',
  Save = 'save',
  Exit = 'exit',
  Sell = 'sell'
}

export type IconProps = {
  name: IconName;
};

export function Icon(props: IconProps): JSX.Element | null {
  switch (props.name) {
    case 'link':
      return <LinkIcon />;
    case 'draw':
      return <DrawIcon />;
    case 'euro':
      return <EuroIcon />;
    case 'arrow-right':
      return <ArrowRightIcon />;
    case 'arrow-up':
      return <ArrowUpIcon />;
    case 'arrow-down':
      return <ArrowDownIcon />;
    case 'arrow-back':
      return <ArrowBackIcon />;
    case 'event-available':
      return <EventAvailableIcon />;
    case 'local-offer':
      return <LocalOfferIcon />;
    case 'travel':
      return <TravelIcon />;
    case 'gift-card':
      return <GiftCardIcon />;
    case 'info':
      return <InfoIcon />;
    case 'home':
      return <HomeIcon />;
    case 'grid':
      return <GridIcon />;
    case 'basket':
      return <BasketIcon />;
    case 'close':
      return <CloseIcon />;
    case 'success':
      return <SuccessIcon />;
    case 'sign-out':
      return <SignOutIcon />;
    case 'arrow-forward':
      return <ArrowForwardIcon />;
    case 'warning':
      return <WarningIcon />;
    case 'double-arrow-left':
      return <DoubleArrowLeftIcon />;
    case 'double-arrow-right':
      return <DoubleArrowRightIcon />;
    case 'hamburger-menu':
      return <HamburgerMenuIcon />;
    case 'file-download':
      return <FileDownloadIcon />;
    case 'file-upload':
      return <FileUploadIcon />;
    case 'file-uploaded':
      return <FileUploadedIcon />;
    case 'calendar':
      return <CalendarIcon />;
    case 'trash':
      return <TrashIcon />;
    case 'employees':
      return <EmployeesIcon />;
    case 'cash-withdrawal':
      return <CashWithdrawalIcon />;
    case 'cash-payment':
      return <CashPaymentIcon />;
    case 'search':
      return <SearchIcon />;
    case 'plus':
      return <PlusIcon />;
    case 'arrow-left':
      return <ArrowLeftIcon />;
    case 'pen':
      return <PenIcon />;
    case 'check':
      return <CheckIcon />;
    case 'home-work':
      return <HomeWorkIcon />;
    case 'checklist':
      return <CheckListIcon />;
    case 'gear':
      return <GearIcon />;
    case 'import':
      return <ImportIcon />;
    case 'invite':
      return <InviteIcon />;
    case 'sync':
      return <Sync />;
    case 'sync-disabled':
      return <SyncDisabled />;
    case 'save':
      return <Save />;
    case 'exit':
      return <Exit />;
    case 'sell':
      return <SellIcon />;
    default:
      return null;
  }
}
